module.exports = __webpack_public_path__ + "static/media/googleLogo.98f8cddc.svg";